The position profile that the history item relates to.

This is null for interactions that are not specific to an individual position,
such as a general interview with a recruiter.
It will also be null where an unknown `profileId` was provided or the position profile has since been deleted.
